import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as uuid from 'uuid';

export enum ButtonType {
	FILLED,
	STROKED,
	BASIC,
	ICON,
	MINI_FAB,
}

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
	@Input() btnType = ButtonType.FILLED;
	@Input() type = 'submit';
	@Input() svgIcon = '';
	@Input() id = uuid.v4();
	@Input() debounceTime = 0;

	// NOTE: If the element has text content, you DON'T need to add aria-label , as it is redundant.
	@Input() ariaLabel?: string;
	@Input() customClass?: string;
	@Input() label?: string;

	@Input() disableRipple = false;
	@Input() isDisabled = false;
	@Input() isLoading = false;
	@Input() hasSpinner = false;
	@Input() isStopPropagation = false;

	@Output() clicked = new EventEmitter<void>();

	readonly buttonType = ButtonType;

	onClick(event: Event): void {
		if (this.isStopPropagation) {
			event.stopPropagation();
		}

		if (!this.isLoading) {
			this.clicked.emit();
		}
	}
}
